import lodashUtils from "./core/lodash-utils";
import webStorage from "./core/web-storage";

var install = function install(Vue) {
  if (install.installed) return;
  lodashUtils.load();
  webStorage.load();
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install: install
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core.js
// module id = 1611
// module chunks = 2